import { ApiResponse } from "../interfaces/ApiResponse"



export default function AlertHandler(response: ApiResponse<any>) {
  /*const title = response.data?.data?.title || null
  const message2 = response.data?.data?.message || null
  message.error(title + ": " + message2)*/

  return response
}
